import React, { useEffect, useState } from "react";
import { Heading } from "../../../../subComponents/Heading";
import { Img } from "../../../../subComponents/img";
import { ReadMore } from "../../../../CommonComponents/readMore";
import { Subheading } from "../../../../subComponents/subHeading";

import AOS from "aos";
import "aos/dist/aos.css";
import { baseurl } from "../../../../CommonComponents/baseurl";
import { NavLink } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Skeleton from "@mui/material/Skeleton";
import { Text } from "../../../../subComponents/text";

const RecentProjectSection = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  const [currentbanner, setCurrentBanner] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await fetch(`${baseurl}/api/our-projects`, {
          method: "GET",
        });

        const data = await response.json();
        if (data.success === "1") {
          setCurrentBanner(data.data);
        } else {
        }
      } catch (error) {
        console.log(error)
      }
    };

    fetchBanner();
  }, []);

  useEffect(() => {}, [currentbanner]);

  return (
    <>
      <section className="recent_project_section" id="recentproject">
        <div style={{ textAlign: "center" }}>
          <Subheading
            title={"Transform your space, transform your life."}
            style={{
              color: "#c82e21",
              fontSize: "1rem",
              textTransform: "uppercase",
            }}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <Heading title={"RECENT PROJECT"} />
        </div>

        <div className="recent_project_container">
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            navigation={true}
            speed={800}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            loop="true"
            breakpoints={{
              200: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1524: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
            modules={[Autoplay, Navigation]}
            className="mySwiper"
          >
            {currentbanner === null ? (
              <div
                className="skeleton_blog_container"
                style={{ width: "100%" }}
              >
                <Skeleton variant="rectangular" width="32%" height={"350px"}>
                  <div style={{ paddingTop: "57%" }} />
                </Skeleton>
                <Skeleton variant="rectangular" width="32%" height={"350px"}>
                  <div style={{ paddingTop: "57%" }} />
                </Skeleton>
                <Skeleton variant="rectangular" width="32%" height={"350px"}>
                  <div style={{ paddingTop: "57%" }} />
                </Skeleton>
              </div>
            ) : (
              currentbanner.map((items) => {
                return (
                  <SwiperSlide key={items.id}    >
                    <div
                      className="recent_project"
                      data-aos="flip-left"
                      data-aos-easing="ease-out-cubic"
                      data-aos-duration="2000"
                    >
                      <div className="home_recent_project_image">
                        <Img
                          src={items.image}
                          style={{ zIndex: "-1" }}
                          alt={items.title}
                        />
                      </div>

                      <div style={{ textDecoration: "none" }}>
                        <div
                          className="recent_project_button"
                          style={{ justifyContent: "start" }}
                        >
                          <div style={{ height: "220px", maxHeight: "220px" }}>
                            {" "}
                            <p
                              style={{
                                textAlign: "start",
                                textTransform: "uppercase",
                                lineHeight: "1rem",
                              }}
                            >
                              {items?.title}
                            </p>
                            <Text
                              text={
                                items?.city === null ? "city name" : items?.city
                              }
                              style={{
                                textAlign: "start",
                                fontSize: "1rem",
                                lineHeight: "0.5rem",
                              }}
                            />
                            <br />
                            <p
                              dangerouslySetInnerHTML={{
                                __html: items?.description,
                              }}
                              style={{
                                textAlign: "start",
                                fontSize: "1rem",
                                fontWeight: "300",
                              }}
                            />
                            <div
                              style={{
                                textAlign: "start",
                                fontSize: "1rem",
                                fontWeight: "300",
                                display: "flex",
                                gap: "0.4rem",
                              }}
                            >
                              {}
                              {[...Array(5)].map((_, index) => {
                                const ratingValue = index + 1;
                                const isFilled = ratingValue <= items?.rating;

                                return (
                                  <span
                                    key={index}
                                    className={
                                      isFilled ? "orange_star" : "gray_star"
                                    }
                                  >
                                    {}
                                    &#9733;
                                  </span>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })
            )}
          </Swiper>
        </div>

        <div
          style={{
            height: "max-content",
            width: "max-content",
            margin: "1rem auto",
          }}
        >
          <br />
          <NavLink to={"/all-recent-project"}>
            <ReadMore />
          </NavLink>
        </div>
      </section>
    </>
  );
};
export { RecentProjectSection };
